// react
import { SyntheticEvent, useCallback, useContext, useEffect, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link as RouterLink, Outlet, useSearchParams, useLocation } from 'react-router-dom';

// mui
import { Container, Grid, Typography } from '@mui/material';

// context
import { ContextIfrs, ContextProject } from '../../Project.context';

// dialogs
import { DialogAddIfr } from '../../../../dialogs/DialogAddIfr/DialogAddIfr';
import { Tabs } from '../../../../ui/Tabs/Tabs';

export const Financial = () => {
	// hooks
	const { pathname } = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// params
	const paramDialog = searchParams.get('dialog');

	// context
	const { refetchIfrs } = useContext(ContextIfrs);
	const { project } = useContext(ContextProject);

	// state
	const [tabValue, setTabValue] = useState('reports');

	// handlers
	const handleChangeTab = (e: SyntheticEvent, value: string) => {
		setTabValue(value);
	};

	const handleCloseDialog = () => {
		searchParams.delete('dialog');
		setSearchParams(searchParams);
	};

	const urlBase = `/project/${project?.idWbg}/reports/financial`;

	const tabs = [
		{
			component: RouterLink,
			label: t('reports'),
			to: `${urlBase}/reports`,
			value: 'reports',
		},
		{
			component: RouterLink,
			label: t('plans'),
			to: `${urlBase}/plans`,
			value: 'plans',
		},
	];

	const getTabByLocation = useCallback((pathname) => {
		if (pathname.includes('financial/plans')) {
			return 'plans';
		}
		return 'reports';
	}, []);

	// set tabValue based on url on initial render
	useEffect(() => {
		const initialTab = getTabByLocation(pathname);
		setTabValue(initialTab);
	}, [pathname, getTabByLocation]);

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Container maxWidth={false}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h2">{t('ifrs')}</Typography>
							</Grid>
						</Grid>
					</Container>
				</Grid>
				<Grid item xs={12}>
					<Tabs hasBorder={false} tabs={tabs} value={tabValue} onChange={handleChangeTab} />
				</Grid>
				<Grid item xs={12}>
					<Outlet />
				</Grid>
			</Grid>
			<DialogAddIfr
				isOpen={paramDialog === 'addReport'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchIfrs();
				}}
			/>
		</>
	);
};
